const convertLocalHoursToUTC = (time) => {
  const hours = time.split(":")[0];
  const minutes = time.split(":")[1];
  let date = new Date();
  date.setHours(hours);
  date.setMinutes(minutes);
  date.setSeconds(0);
  date.setMilliseconds(0);
  let utc = date.toISOString().split("T")[1].split(".")[0];
  utc = utc.split(":").slice(0, 2).join(":");
  return utc;
};

export default convertLocalHoursToUTC;
